(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pagani-product-main"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.pagani-product-shell').forEach((shell) => {
    const mainImage = shell.querySelector('.pagani-product-main-image');
    const thumbnails = Array.from(shell.querySelectorAll('[data-pagani-thumbnail]'));
    let activeIndex = Math.max(0, thumbnails.findIndex((thumbnail) => thumbnail.classList.contains('is-active')));

    const activateThumbnail = (index) => {
      if (!mainImage || thumbnails.length === 0) return;
      activeIndex = (index + thumbnails.length) % thumbnails.length;
      thumbnails.forEach((thumbnail, thumbnailIndex) => thumbnail.classList.toggle('is-active', thumbnailIndex === activeIndex));
      const thumbnail = thumbnails[activeIndex];
      mainImage.removeAttribute('srcset');
      mainImage.src = thumbnail.dataset.fullSrc;
      mainImage.alt = thumbnail.dataset.imageAlt || '';
      mainImage.style.opacity = '0.82';
      window.requestAnimationFrame(() => {
        mainImage.style.opacity = '1';
      });
      thumbnail.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'nearest' });
    };

    thumbnails.forEach((thumbnail, index) => thumbnail.addEventListener('click', () => activateThumbnail(index)));
    shell.querySelector('[data-gallery-previous]')?.addEventListener('click', () => activateThumbnail(activeIndex - 1));
    shell.querySelector('[data-gallery-next]')?.addEventListener('click', () => activateThumbnail(activeIndex + 1));

    const mediaStage = shell.querySelector('.pagani-product-main-media');
    let pointerStartX = 0;
    let pointerStartY = 0;
    mediaStage?.addEventListener('dragstart', (event) => event.preventDefault());
    mediaStage?.addEventListener('pointerdown', (event) => {
      if (event.target.closest('button')) return;
      pointerStartX = event.clientX;
      pointerStartY = event.clientY;
      mediaStage.setPointerCapture?.(event.pointerId);
    });
    mediaStage?.addEventListener('pointerup', (event) => {
      if (event.target.closest('button')) return;
      const deltaX = event.clientX - pointerStartX;
      const deltaY = event.clientY - pointerStartY;
      if (Math.abs(deltaX) < 40 || Math.abs(deltaX) <= Math.abs(deltaY) * 1.2) return;
      activateThumbnail(activeIndex + (deltaX < 0 ? 1 : -1));
    });

    const quantityInput = shell.querySelector('input[name="quantity"]');
    shell.querySelector('[data-quantity-decrease]')?.addEventListener('click', () => {
      quantityInput.value = Math.max(1, Number(quantityInput.value || 1) - 1);
      quantityInput.dispatchEvent(new Event('change', { bubbles: true }));
    });
    shell.querySelector('[data-quantity-increase]')?.addEventListener('click', () => {
      quantityInput.value = Math.max(1, Number(quantityInput.value || 1) + 1);
      quantityInput.dispatchEvent(new Event('change', { bubbles: true }));
    });

    const stickyQuantityValue = shell.querySelector('[data-sticky-quantity-value]');
    const syncStickyQuantity = () => {
      if (stickyQuantityValue) stickyQuantityValue.textContent = quantityInput.value;
    };
    quantityInput.addEventListener('change', syncStickyQuantity);
    shell.querySelector('[data-sticky-quantity-decrease]')?.addEventListener('click', () => {
      quantityInput.value = Math.max(1, Number(quantityInput.value || 1) - 1);
      quantityInput.dispatchEvent(new Event('change', { bubbles: true }));
    });
    shell.querySelector('[data-sticky-quantity-increase]')?.addEventListener('click', () => {
      quantityInput.value = Math.max(1, Number(quantityInput.value || 1) + 1);
      quantityInput.dispatchEvent(new Event('change', { bubbles: true }));
    });
    syncStickyQuantity();

    const productForm = shell.querySelector('[data-pagani-product-form]');
    productForm?.addEventListener('submit', async (event) => {
      event.preventDefault();
      const submitButton = event.submitter;
      const errorMessage = productForm.querySelector('[data-pagani-cart-error]');
      if (!(submitButton instanceof HTMLButtonElement) || submitButton.dataset.loading === 'true') return;

      const checkoutAfterAdd = submitButton.hasAttribute('data-pagani-checkout');
      const purchaseButtons = [
        ...productForm.querySelectorAll('button[type="submit"]'),
        ...document.querySelectorAll(`button[form="${productForm.id}"]`),
      ];
      const cartDrawer = document.querySelector('cart-drawer');
      if (cartDrawer && !checkoutAfterAdd) cartDrawer.setActiveElement(submitButton);

      submitButton.dataset.loading = 'true';
      purchaseButtons.forEach((button) => { button.disabled = true; });
      if (errorMessage) errorMessage.hidden = true;

      const formData = new FormData(productForm);
      if (cartDrawer && !checkoutAfterAdd) {
        formData.append('sections', cartDrawer.getSectionsToRender().map((item) => item.id));
        formData.append('sections_url', window.location.pathname);
      }

      try {
        const response = await fetch(window.routes?.cart_add_url || '/cart/add.js', {
          method: 'POST',
          headers: {
            Accept: 'application/json',
            'X-Requested-With': 'XMLHttpRequest',
          },
          body: formData,
        });
        const cartResponse = await response.json();
        if (!response.ok || cartResponse.status) throw new Error(cartResponse.description || cartResponse.message);

        if (checkoutAfterAdd) {
          window.location.assign('/checkout');
        } else if (cartDrawer) {
          cartDrawer.renderContents(cartResponse);
        } else {
          window.location.assign(window.routes?.cart_url || '/cart');
        }
      } catch (error) {
        if (errorMessage) errorMessage.hidden = false;
      } finally {
        submitButton.dataset.loading = 'false';
        purchaseButtons.forEach((button) => { button.disabled = false; });
      }
    });

    const cepForm = shell.querySelector('[data-cep-form]');
    cepForm?.addEventListener('submit', (event) => {
      event.preventDefault();
      const input = cepForm.querySelector('input');
      const message = cepForm.querySelector('[data-cep-message]');
      const results = cepForm.querySelector('[data-shipping-results]');
      const digits = input.value.replace(/\D/g, '');
      const isValid = digits.length === 8;
      message.textContent = isValid ? '' : cepForm.dataset.errorMessage;
      results.hidden = !isValid;
    });

    const buyButton = shell.querySelector('[data-pagani-main-buy]');
    const stickyBar = shell.querySelector('[data-product-sticky]');
    const footer = document.querySelector('footer, #shopify-section-footer');
    const reviewWidget = document.querySelector('.jdgm-review-widget');
    if (buyButton && stickyBar && 'IntersectionObserver' in window) {
      let buyButtonIsVisible = true;
      let footerIsVisible = false;
      let reviewWidgetIsVisible = false;
      const updateStickyVisibility = () => {
        stickyBar.classList.toggle('is-visible', !buyButtonIsVisible && !footerIsVisible && !reviewWidgetIsVisible);
      };

      new IntersectionObserver(([entry]) => {
        buyButtonIsVisible = entry.isIntersecting;
        updateStickyVisibility();
      }, { threshold: 0.15 }).observe(buyButton);

      if (footer) {
        new IntersectionObserver(([entry]) => {
          footerIsVisible = entry.isIntersecting;
          updateStickyVisibility();
        }, { threshold: 0.01 }).observe(footer);
      }

      if (reviewWidget) {
        new IntersectionObserver(([entry]) => {
          reviewWidgetIsVisible = entry.isIntersecting;
          updateStickyVisibility();
        }, { threshold: 0.01 }).observe(reviewWidget);
      }
    }
  });

  (() => {
    const exactText = new Map([
      ['Sort reviews by', 'Ordenar avaliações por'],
      ['Thumbnail Navigation', 'Navegação das miniaturas'],
      ['Customer Reviews', 'Avaliações de Clientes'],
      ['Write a review', 'Escrever uma avaliação'],
      ['Close review form', 'Fechar formulário de avaliação'],
      ['Review form pages', 'Etapas do formulário de avaliação'],
      ['Rating', 'Avaliação'],
      ['Privacy and Terms', 'Privacidade e termos'],
      ['View review image', 'Ver imagem da avaliação'],
      ['Review Image', 'Imagem da avaliação'],
      ['Previous image', 'Imagem anterior'],
      ['Next image', 'Próxima imagem'],
      ['Photo gallery', 'Galeria de fotos'],
      ['Load more', 'Mostrar mais'],
      ['No items found', 'Nenhum item encontrado'],
    ]);

    const translateValue = (value) => {
      if (!value) return value;
      if (exactText.has(value.trim())) return exactText.get(value.trim());

      let match = value.trim().match(/^(\d+(?:[.,]\d+)?) out of 5 stars$/i);
      if (match) return `${match[1]} de 5 estrelas`;

      match = value.trim().match(/^Average rating is (\d+(?:[.,]\d+)?) stars$/i);
      if (match) return `A avaliação média é de ${match[1]} estrelas`;

      match = value.trim().match(/^(\d+)% \((\d+)\) reviews? with (\d+) star rating$/i);
      if (match) return `${match[1]}% (${match[2]}) avaliações com nota de ${match[3]} estrelas`;

      match = value.trim().match(/^(\d+) stars?$/i);
      if (match) return `${match[1]} ${match[1] === '1' ? 'estrela' : 'estrelas'}`;

      match = value.trim().match(/^Based on (\d+) reviews?$/i);
      if (match) return `Baseado em ${match[1]} ${match[1] === '1' ? 'avaliação' : 'avaliações'}`;

      return value;
    };

    const translateJudgeMe = () => {
      const roots = document.querySelectorAll('.jdgm-review-widget, .jdgm-review-widget-modal');
      roots.forEach((root) => {
        root.classList.toggle('pagani-review-empty', root.matches('.jdgm-review-widget') && !root.querySelector('.jm-review-item'));

        root.querySelectorAll('.jdgm-write-review-modal__product-image img').forEach((image) => {
          if (!image.hasAttribute('width')) image.setAttribute('width', '200');
          if (!image.hasAttribute('height')) image.setAttribute('height', '200');
        });

        root.querySelectorAll('[aria-label], [title], [alt]').forEach((element) => {
          ['aria-label', 'title', 'alt'].forEach((attribute) => {
            const current = element.getAttribute(attribute);
            const translated = translateValue(current);
            if (current && translated !== current) element.setAttribute(attribute, translated);
          });
        });

        const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
        let node;
        while ((node = walker.nextNode())) {
          const current = node.nodeValue;
          const translated = translateValue(current);
          if (translated !== current) node.nodeValue = translated;
        }
      });
    };

    let translationFrame;
    const scheduleTranslation = () => {
      window.cancelAnimationFrame(translationFrame);
      translationFrame = window.requestAnimationFrame(translateJudgeMe);
    };

    scheduleTranslation();
    new MutationObserver(scheduleTranslation).observe(document.body, {
      childList: true,
      subtree: true,
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pagani-product-story"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function normalizePaganiProductFaqOrder() {
      document.querySelectorAll('.pagani-product-story').forEach(function (story) {
        var packaging = story.querySelector('.pagani-product-packaging');
        var characteristics = story.querySelector('.pagani-nautilus-specs, .pagani-scroll-characteristics');
        var faqCandidates = Array.prototype.slice.call(
          story.querySelectorAll('.pagani-nautilus-faq, .pagani-scroll-details, .pagani-generated-faq')
        ).filter(function (faq) {
          return !faq.parentElement.closest('.pagani-nautilus-faq, .pagani-scroll-details, .pagani-generated-faq');
        });

        if (!packaging) return;

        if (characteristics) {
          characteristics.parentNode.insertBefore(packaging, characteristics);
        } else if (faqCandidates.length) {
          faqCandidates[0].parentNode.insertBefore(packaging, faqCandidates[0]);
        }

        if (!faqCandidates.length) return;

        var firstFaq = faqCandidates[0];
        var faqParent = firstFaq.parentNode;

        faqParent.classList.add('pagani-faq-stack-parent');

        faqCandidates.forEach(function (faq) {
          faq.classList.add('pagani-faq-aligned');
          faqParent.appendChild(faq);
        });
      });
    }

    function initPaganiScrollStories() {
      document.querySelectorAll('[data-pagani-scroll-story]').forEach(function (story) {
        if (story.dataset.ready === 'global-v71') return;

        story.dataset.ready = 'global-v71';
        var steps = Array.prototype.slice.call(story.querySelectorAll('.pagani-scroll-step'));
        var images = Array.prototype.slice.call(story.querySelectorAll('[data-step-image]'));

        if (!steps.length || !images.length) return;

        var current = -1;

        function setActive(index) {
          index = Math.max(0, Math.min(index, steps.length - 1));
          if (index === current) return;

          current = index;
          steps.forEach(function (step, stepIndex) {
            step.classList.toggle('is-active', stepIndex === index);
          });
          images.forEach(function (image, imageIndex) {
            image.classList.toggle('is-active', imageIndex === index);
          });
        }

        function pickActiveStep() {
          var target = window.innerHeight * 0.48;
          var active = 0;
          var distance = Infinity;

          steps.forEach(function (step, index) {
            var rect = step.getBoundingClientRect();
            var center = rect.top + rect.height * 0.5;
            var visible = Math.max(0, Math.min(rect.bottom, window.innerHeight) - Math.max(rect.top, 0));
            var nextDistance = Math.abs(center - target) - Math.min(visible, rect.height) * 0.18;

            if (nextDistance < distance) {
              distance = nextDistance;
              active = index;
            }
          });

          return active;
        }

        function requestUpdate() {
          window.requestAnimationFrame(function () {
            setActive(pickActiveStep());
          });
        }

        if ('IntersectionObserver' in window) {
          var observer = new IntersectionObserver(requestUpdate, {
            root: null,
            rootMargin: '-18% 0px -32% 0px',
            threshold: [0, 0.2, 0.45, 0.7, 1]
          });

          steps.forEach(function (step) {
            observer.observe(step);
          });
        }

        window.addEventListener('scroll', requestUpdate, { passive: true });
        window.addEventListener('resize', requestUpdate);
        setActive(0);
        setTimeout(requestUpdate, 300);
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        initPaganiScrollStories();
        normalizePaganiProductFaqOrder();
      });
    } else {
      initPaganiScrollStories();
      normalizePaganiProductFaqOrder();
    }

    document.addEventListener('shopify:section:load', function () {
      initPaganiScrollStories();
      normalizePaganiProductFaqOrder();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["slideshow"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initialize = (root) => {
      if (!root || root.dataset.initialized === 'true') return;

      const slides = Array.from(root.querySelectorAll('[data-pagani-banner-slide]'));
      const dots = Array.from(root.querySelectorAll('[data-pagani-banner-dot]'));
      const previous = root.querySelector('[data-pagani-banner-prev]');
      const next = root.querySelector('[data-pagani-banner-next]');
      const autoplay = root.dataset.autoplay === 'true' && !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      const speed = Number(root.dataset.speed) || 5000;
      let current = 0;
      let timer;

      const show = (index) => {
        if (!slides.length) return;
        current = (index + slides.length) % slides.length;
        slides.forEach((slide, slideIndex) => {
          const active = slideIndex === current;
          slide.hidden = !active;
          slide.setAttribute('aria-hidden', String(!active));
        });
        dots.forEach((dot, dotIndex) => {
          const active = dotIndex === current;
          dot.classList.toggle('is-active', active);
          dot.setAttribute('aria-current', String(active));
        });
      };

      const stop = () => window.clearInterval(timer);
      const start = () => {
        stop();
        if (autoplay && slides.length > 1) timer = window.setInterval(() => show(current + 1), speed);
      };

      previous?.addEventListener('click', () => {
        show(current - 1);
        start();
      });
      next?.addEventListener('click', () => {
        show(current + 1);
        start();
      });
      dots.forEach((dot) => dot.addEventListener('click', () => {
        show(Number(dot.dataset.paganiBannerDot));
        start();
      }));
      root.addEventListener('mouseenter', stop);
      root.addEventListener('mouseleave', start);
      root.addEventListener('focusin', stop);
      root.addEventListener('focusout', start);
      document.addEventListener('visibilitychange', () => document.hidden ? stop() : start());

      root.dataset.initialized = 'true';
      show(0);
      start();
    };

    const initializeAll = (scope = document) => scope.querySelectorAll('[data-pagani-banners]').forEach(initialize);
    initializeAll();
    document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));
  })();

  } catch(e) { console.error(e); }
})();
})();
